import { createFileRoute } from "@tanstack/react-router";
import { AuthRequired } from "@/components/auth/AuthRequired";
import { LeagueSettingsPage } from "@/components/rank/LeagueSettingsPage";
import { buildHead } from "@/lib/seo";

// Full-screen league settings page (owner only; gated inside the component).
export const Route = createFileRoute("/_app/rank_/$leagueId_/settings")({
  head: ({ params }) =>
    buildHead({ path: `/rank/${params.leagueId}/settings`, title: "League settings", noindex: true }),
  component: Settings,
});

function Settings() {
  const { leagueId } = Route.useParams();
  return (
    <AuthRequired>
      <LeagueSettingsPage leagueId={leagueId} />
    </AuthRequired>
  );
}
